import { render, staticRenderFns } from "./AntiFraudConfigHistoryModal.vue?vue&type=template&id=0ddee13f"
import script from "./AntiFraudConfigHistoryModal.vue?vue&type=script&lang=js"
export * from "./AntiFraudConfigHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./AntiFraudConfigHistoryModal.vue?vue&type=style&index=0&id=0ddee13f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports